<template>
  <article class="page">
    <p class="subtitle">
      Gestiona y administra tus perfiles.
      <a :href="DOCS_URL" target="_blank" rel="noopener noreferrer">Click aquí</a> para conocer más.
    </p>
    <div class="search-input">
      <a-input
        v-model:value="search"
        placeholder="Buscar perfil..."
        class="form__input"
        @input="handleSearch"
      >
        <template #prefix>
          <SearchOutlined />
        </template>
      </a-input>
    </div>
    <CustomScrollbar class="panel" height="500px" auto>
      <a-spin :spinning="loading">
        <div class="profiles">
          <profile-card-creator @click="handleCreateModal" />
          <profile-card
            v-for="(profile, index) in profiles"
            :id="`profile-card-${index}`"
            :key="profile.id"
            :profile="profile"
            @onEdit="handleEditProfile"
            @onDelete="handleDeleteProfile"
            @onSimpleDelete="handleSearch"
          />
        </div>
      </a-spin>

      <profiles-modal-create
        v-if="creatorModal"
        :value="creatorModal"
        @onClose="handleCreateClose('create')"
      />
      <profiles-modal-edit
        v-if="editorModal"
        :value="editorModal"
        @onClose="handleCreateClose('edit')"
      />
      <profiles-modal-delete
        v-if="deleteModal"
        :visible="deleteModal"
        @onCancel="handleCreateClose('delete', $event)"
      />
    </CustomScrollbar>
  </article>
</template>

<script>
import ProfileCard from "@/app/users/components/cards/ProfileCard.vue";
import ProfileCardCreator from "@/app/users/components/cards/ProfileCardCreator.vue";
import ProfilesModalCreate from "@/app/users/components/modals/ProfilesModalCreate.vue";
import ProfilesModalEdit from "@/app/users/components/modals/ProfilesModalEdit.vue";
import CustomScrollbar from "@/app/shared/components/organisms/CustomScrollbar.vue";
import ProfilesModalDelete from "@/app/users/components/modals/DeleteProfileModal.vue";
import { SearchOutlined } from "@ant-design/icons-vue";
import { defineComponent } from "vue";

export default defineComponent({
  components: {
    ProfileCard,
    ProfilesModalEdit,
    ProfilesModalCreate,
    ProfileCardCreator,
    CustomScrollbar,
    SearchOutlined,
    ProfilesModalDelete,
  },
  data() {
    const DOCS_URL = `${import.meta.env.VITE_WEB_DOC}/menu-usuario/equipo-de-trabajo/perfiles/`;

    return {
      creatorModal: false,
      editorModal: false,
      deleteModal: false,
      imagen: "",
      search: "",
      loading: false,
      DOCS_URL,
    };
  },
  computed: {
    profiles() {
      return this.$store.getters["getProfileList"];
    },
  },
  mounted() {
    this.handleSearch();
  },
  methods: {
    async handleSearch() {
      this.loading = true;
      await this.$store.dispatch("fetchAllProfiles", { search: this.search });
      this.loading = false;
    },
    handleCreateModal() {
      this.creatorModal = true;
    },
    handleEditProfile() {
      this.editorModal = true;
    },
    handleDeleteProfile() {
      this.deleteModal = true;
    },
    async handleCreateClose(type) {
      switch (type) {
        case "create":
          this.creatorModal = false;
          break;
        case "edit":
          this.editorModal = false;
          break;
        case "delete":
          this.deleteModal = false;
          break;
        default:
          break;
      }

      await this.handleSearch();
    },
  },
});
</script>

<style lang="sass" scoped>
.profiles
  gap: 12px
  display: grid
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr))

.subtitle
  color: $gray-9

.panel
  max-height: 700px
  background-color: white
  border-radius: 2px
  margin: 4px 0 12px 0

.search-input
  display: flex
  margin-bottom: 24px
  width: 25%
</style>
